import { useState } from "react";
import { GameState } from "../App";
import { Answer, QuestionLibrary } from "../models/Question";
import "./Game.scss";
import { TreasureChest } from "./Treasure-Chest";

export interface Props {
  setGameState: (gameState: GameState) => void;
}

export const Game: React.FC<Props> = ({ setGameState }) => {
  const [question, setQuestion] = useState(QuestionLibrary[0]);
  const [failedState, setFailedState] = useState(false);
  const [failedText, setFailedText] = useState("");

  const onClickAnswer = (answer: Answer | undefined) => {
    if (answer?.correct) {
      const currentQuestionId = question.id;
      setQuestion(QuestionLibrary[currentQuestionId + 1]);
    } else {
      setFailedText(answer?.additionalText ? answer.additionalText : "BUG");
      setFailedState(true);
    }
  };

  return (
    <div className="game">
      {failedState ? (
        <div className="failed">
          <div className="failed-text">{failedText}</div>
          <button onClick={() => setGameState("reset")}>Continue...</button>
        </div>
      ) : (
        <>
          {question.id + 1 === QuestionLibrary.length ? (
            <TreasureChest
              setGameState={setGameState}
              firstText={question.text}
            />
          ) : (
            <div className="progress">
              <div className="question">{question.text}</div>
              <div className="answers">
                <button
                  className={"answer-button"}
                  onClick={() => onClickAnswer(question.answer1)}
                >
                  {question.answer1?.text}
                </button>
                <button
                  className={"answer-button"}
                  onClick={() => onClickAnswer(question.answer2)}
                >
                  {question.answer2?.text}
                </button>
                <button
                  className={"answer-button"}
                  onClick={() => onClickAnswer(question.answer3)}
                >
                  {question.answer3?.text}
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};
